import * as React from "react";

export const Pill: React.FC<{
	name: string;
}> = ({ name }) => {
	return <span className="badge rounded-pill bg-success">{name}</span>;
};

export default Pill;
